export enum SlotMachineEvent {
    STATE_CHANGED = 'onSlotMachineStateChanged',
    BET_VALUE_CHANGED = 'onSlotMachineBetValueChanged',
    GAME_SPEED_LEVEL_CHANGED = 'onSlotMachineGameSpeedLevelChanged',
}
